module.exports = __webpack_public_path__ + "media/old_images/logo-hitta-orientering-0db96bfa.png";